import React from 'react';
import { useSelector } from 'react-redux';
import getRewardsSummary from 'store/dashboard/selector/getRewardsSummary';
import { useTranslation } from 'react-i18next';
import RewardsImage from 'assets/images/rewards/rewardsCoin.png';
import OpText from 'components/Common/op-ui-wrappers/OpText/OpText';
import styles from './RewardsStatus.module.scss';

const RewardsStatus = () => {
  const rewardsSummary = useSelector(getRewardsSummary);
  const { t } = useTranslation();

  const zeroState = (
    <>
      <div className={styles.background}>
        <img src={RewardsImage} alt="Rewards" />
      </div>
      <OpText variant="body-large-regular" className={styles.text}>
        {t('txt_no_store_credits')}
      </OpText>
    </>
  );

  const rewardsSummaryEl = (
    <>
      <div className={styles.background}>
        <div className={styles.amount}>
          <OpText variant="headline-small-bold">
            <div dangerouslySetInnerHTML={{ __html: rewardsSummary.amountFormatted }} />
          </OpText>
          <OpText variant="body-large-bold">{t('txt_store_credits')}</OpText>
        </div>
      </div>
      <OpText variant="body-large-regular" className={styles.text}>
        <div dangerouslySetInnerHTML={{ __html: t('txt_store_credit_expire_at', { date: rewardsSummary.expireAt }) }} />
      </OpText>
    </>
  );

  return <div className={styles.container}>{rewardsSummary.amount ? rewardsSummaryEl : zeroState}</div>;
};

export default RewardsStatus;
